import {
  ChangeEvent, useCallback, useState, useEffect,
} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { defaultFulfillmentCenterTypeFilters } from 'src/features/fulfillmentCenterFilters'
import { selectFulfillmentCenters } from 'src/features/selector'
import ProductHeader from '../../components/ProductHeader'
import ProductTabs from '../../components/ProductTabs'
import { selectProduct } from '../../StockManagementSeletor'
import { GetProduct } from '../../StockManagementTypes'
import { actions } from '../../StockManagementState'
import { actions as actionsFC } from '../../../state'

export default () => {
  const history = useHistory()
  const dispatch = useDispatch()

  const FCs = useSelector(selectFulfillmentCenters)
  const product = useSelector(selectProduct)

  const { fulfillmentCenterId, modelId } = useParams() as unknown as GetProduct
  const [currentFC, setCurrentFC] = useState(fulfillmentCenterId)

  const handleClickSearchButton = useCallback(() => {
    history.push(`/stock-managment/product/${currentFC}/${modelId}`)
  }, [currentFC, history, modelId])

  const handleChangeFulfillmentCenterSelect = (event: ChangeEvent<HTMLSelectElement>) => {
    const FC = Number(event.target.value)
    setCurrentFC(FC)
  }

  const handleClickBackButton = useCallback(() => {
    history.push('/stock-managment/list?backFromProduct=true')
  }, [history])

  useEffect(() => {
    dispatch(actionsFC.getAvailableFulfillmentCenters(defaultFulfillmentCenterTypeFilters))
  }, [dispatch])

  useEffect(() => {
    dispatch(
      actions.setProductTabsFilters({ fulfillmentCenterId, modelId }),
    )

    dispatch(
      actions.getProduct({
        fulfillmentCenterId: fulfillmentCenterId as number,
        modelId: modelId as number,
      }),
    )

    return () => {
      dispatch(actions.clearProductTabs())
      dispatch(actions.setProduct(null))
    }
  }, [fulfillmentCenterId, modelId, dispatch])

  return (
    <div>
      <ProductHeader
        FCs={FCs}
        product={product}
        currentFC={currentFC}
        handleChangeSelect={handleChangeFulfillmentCenterSelect}
        handleClickBackButton={handleClickBackButton}
        handleClickSearchButton={handleClickSearchButton}
      />
      <ProductTabs />
    </div>
  )
}
